import { SettingsNav, TRAIN_ROWS } from '@elva/ui';
import { Outlet, useLocation, useNavigate } from 'react-router-dom';
import { useClearPageTopBarActions } from '@/app/layouts/pageTopBar';

/**
 * The settings shell (spec 15 §2). Two nav columns sit left of every settings
 * page: the app rail (already built, not rebuilt here) and this 258px column.
 *
 * §2.4 is the one thing the boards cannot show: the column is NOT as tall as the
 * page. It fills the available height and scrolls inside itself, so a 3,000px
 * page (Calendar insights, the Brain) does not produce a 3,000px nav column.
 */
export function SettingsLayout() {
  useClearPageTopBarActions();
  const { pathname } = useLocation();
  const navigate = useNavigate();

  return (
    <div className="cal-fade mx-auto flex min-h-0 w-full max-w-[1500px] flex-1 gap-[22px] overflow-hidden px-[30px] pb-5 pt-5">
      <SettingsNav
        activeRoute={pathname}
        onNavigate={(route) => {
          void navigate(route);
        }}
        // Derived from the same array Train ELVA draws its rows from (F21). Resolving
        // a row on that page does not update this badge until reload — there is no
        // train-queue API to share.
        // 29 queue rows + the one "Your rules" entry that needs a change = 30 (§6).
        badges={{ trainElva: TRAIN_ROWS.length + 1 }}
      />
      <div className="min-h-0 flex-1 overflow-y-auto pb-16">
        <Outlet />
      </div>
    </div>
  );
}
